export function ActorMark({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 48 48" className={className} fill="none" aria-hidden="true">
      <circle cx="17" cy="10" r="5" stroke="currentColor" strokeWidth="2.4" />
      <path
        d="M17 15v15m0-9-8 6m8-6 8 5m-8 4-6 11m6-11 8 10"
        stroke="currentColor"
        strokeWidth="2.4"
        strokeLinecap="round"
      />
      <path
        d="M25 8c5-4 13-2 15 3 1 3-1 6-4 8l1 5-6-3c-3 0-5-2-6-4"
        stroke="#e08a71"
        strokeWidth="2.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m29 13 2-1m3 0 2 1"
        stroke="#e08a71"
        strokeWidth="1.8"
        strokeLinecap="round"
      />
    </svg>
  );
}